import React, { useEffect, useState } from "react";

const ViewBidsModal = ({ open, onClose, ride, onAccept, onReject, loading }) => {
  const [bids, setBids] = useState([]);
  const [error, setError] = useState(null);
  const [loadingBids, setLoadingBids] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const fetchBids = async () => {
    if (!ride?.id || !open) return;
    try {
      setLoadingBids(true);
      setError(null);
      const base = process.env.REACT_APP_MINIAPP_API_BASE_URL || "/telegramMiniApp";
      const initData = window?.Telegram?.WebApp?.initData;
      const resp = await fetch(`${base}/rides/${ride.id}/bids`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ initData })
      });
      const data = await resp.json();
      if (!data?.success) throw new Error(data?.error || 'Failed to load bids');
      setBids(data.data || []);
    } catch (e) {
      setError(e.message || 'Failed to load bids');
    } finally {
      setLoadingBids(false);
    }
  };

  useEffect(() => {
    fetchBids();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ride?.id, open, refreshKey]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="w-full max-w-lg rounded-xl border border-white/10 bg-neutral-950 p-5 shadow-2xl shadow-black/60">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-white">Bids for this ride</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setRefreshKey(k => k + 1)} className="bw-btn-ghost" disabled={loadingBids}>{loadingBids ? 'Refreshing…' : 'Refresh'}</button>
            <button onClick={onClose} className="bw-btn-ghost">✕</button>
          </div>
        </div>
        {error && <div className="mb-4 text-sm text-red-500">{error}</div>}
        {loadingBids ? (
          <div className="text-sm bw-muted">Loading bids…</div>
        ) : bids.length === 0 ? (
          <div className="text-sm bw-muted">No active bids yet. Please check back soon.</div>
        ) : (
          <ul className="space-y-2">
            {bids.map(b => (
              <li key={b.id} className="rounded border border-white/10 bg-black p-3">
                <div className="flex items-center justify-between text-sm">
                  <div>
                    <div className="font-semibold text-white">{`$${b.amount.toFixed(2)}`}</div>
                    <div className="text-xs bw-muted">{b.driver?.name || 'Driver'} {b.driver?.username ? `(@${b.driver.username})` : ''}</div>
                  </div>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => onReject?.(b)}
                      disabled={loading}
                      className="bw-btn-ghost"
                    >
                      Decline
                    </button>
                    <button
                      type="button"
                      onClick={() => onAccept?.(b)}
                      disabled={loading}
                      className="bw-btn"
                    >
                      Accept
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ViewBidsModal;
